import { createAction, props } from '@ngrx/store';
import { MemberLogs } from './member-logs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records member log',
    props<{ memberId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records member log success', 
    props<{ listData: MemberLogs[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records member log failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state member log',
);
